// extracted by mini-css-extract-plugin
export default {"wrapper":"Key_wrapper__vA3Qg","file":"Key_file__tVgvk","btnRemove":"Key_btnRemove__2WJGG","list":"Key_list__yGNwM","row":"Key_row__GmNpb","btnImg":"Key_btnImg__b-6u9"};